import * as React from "react";
import { forwardRef } from "react";
const ProgressSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { d: "M19.337 10.135a1 1 0 0 0 1.91-.594l-1.86-5.972-5.97 1.86a1 1 0 1 0 .594 1.909l2.655-.827-4.03 7.104-4.042-2.425a1.1 1.1 0 0 0-1.461.304l-4.947 6.925a1 1 0 0 0 1.628 1.162l4.463-6.248 4.12 2.472a1.1 1.1 0 0 0 1.523-.4l4.557-8.032z" }));
const ForwardRef = forwardRef(ProgressSVG);
export default ForwardRef;
//# sourceMappingURL=Progress.js.map